import type { ZudokuConfig } from "zudoku";

export const docs: ZudokuConfig["docs"] = {
  files: "/pages/**/*.mdx",
  publishMarkdown: true,
  defaultOptions: {
    copyPage: false,
  },
  llms: {
    llmsTxt: true,
    includeProtected: false,
  },
};
